import { OrderStepFunctionContainer } from "./models";
import { SNSDetail } from "./sNSDetail";

export interface SNSMessage {
  version?: string;
  source?: SNSMessage.SourceEnum;
  transactionSource?: OrderStepFunctionContainer.TransactionSourceEnum;
  eventType?: SNSMessage.EventTypeEnum;
  correlationId?: string;
  details?: SNSDetail;
}

export namespace SNSMessage {
  export type SourceEnum = "OrderManagement" | "Bulk" | "PatientMedications";
  export const SourceEnum = {
    OrderManagement: "OrderManagement" as SourceEnum,
    Bulk: "Bulk" as SourceEnum,
    PatientMedications: "PatientMedications" as SourceEnum,
  };
  export type EventTypeEnum = "OrderCreate" | "OrderPatch";
  export const EventTypeEnum = {
    OrderCreate: "OrderCreate" as EventTypeEnum,
    OrderPatch: "OrderPatch" as EventTypeEnum,
  };
}



// WEBPACK FOOTER //
// ./src/models/order-management/sNSMessage.ts